export const URL = "//isafety.pt"

//"//isafety.pt"

//"http://localhost:3000"